import { render } from "./ItemBadge.vue?vue&type=template&id=15db0e4e"
import script from "./ItemBadge.vue?vue&type=script&lang=js"
export * from "./ItemBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__